
export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-md">
        <nav className="container mx-auto px-6 py-4">
          <a href="/" className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            株式会社eta
          </a>
        </nav>
      </header>

      <main className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-800 mb-8" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            プライバシーポリシー
          </h1>

          <div className="bg-white border-2 border-gray-300 p-8 space-y-8" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                個人情報の取り扱いについて
              </h2>
              <p className="text-gray-700 leading-relaxed">
                株式会社eta（以下「当社」）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」）を遵守すると共に、以下のプライバシーポリシー（以下「本ポリシー」）に従い、適切な取扱い及び保護に努めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                1. 個人情報の定義
              </h2>
              <p className="text-gray-700 leading-relaxed">
                本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）を指します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                2. 個人情報の収集方法
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                当社は、以下の方法により個人情報を収集することがあります。
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>お問い合わせフォームからのご入力</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>サービスのお申し込み</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>その他、当社が提供するサービスのご利用</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                3. 個人情報の利用目的
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                当社は、収集した個人情報を以下の目的で利用いたします。
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>お問い合わせへの対応</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>サービスの提供及び運営</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>サービスに関する情報のご案内</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>その他、上記利用目的に付随する目的</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                4. 個人情報の第三者提供
              </h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
              <ul className="space-y-2 text-gray-700 mt-3">
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>法令に基づく場合</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-green-700 mt-1">●</span>
                  <span>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                5. 個人情報の安全管理
              </h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                6. お問い合わせ
              </h2>
              <p className="text-gray-700 leading-relaxed">
                個人情報の取扱いに関するお問い合わせは、当社お問い合わせフォームよりご連絡ください。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-700" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                7. プライバシーポリシーの変更
              </h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、本ポリシーの内容を適宜見直し、その改善に努めます。本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、変更することができるものとします。
              </p>
            </section>

            <div className="mt-8 pt-8 border-t-2 border-gray-300">
              <p className="text-gray-700">
                制定日：2016年05月10日<br />
                株式会社eta<br />
                代表取締役　二宮　妃時
              </p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <a 
              href="/"
              className="inline-block px-8 py-3 bg-green-700 text-white font-medium hover:bg-green-800 transition-colors duration-300 whitespace-nowrap"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              トップページに戻る
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
